/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {DetailEventTagDTO} from '../model/detailEventTagDTO';
import {IHistoryEvent} from '../model/iHistoryEvent';
import {IPersonalStatusLite} from '../model/iPersonalStatusLite';
import {IPersonalTagLite} from '../model/iPersonalTagLite';
import {ITimbreQte} from '../model/iTimbreQte';
import {TagEventPersonalDTO} from '../model/tagEventPersonalDTO';
import {TagStatusDTO} from '../model/tagStatusDTO';
import {UpdateTagByDataviewDTO} from '../model/updateTagByDataviewDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EngineTagEventPersonalService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<TagEventPersonalDTO>;
    public createTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagEventPersonalDTO>>;
    public createTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagEventPersonalDTO>>;
    public createTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createTagEventPersonal.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTagEventPersonal.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TagEventPersonalDTO>('post',`${this.basePath}/api/tag-event-personals`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTagEventPersonal(xDataStoreID: string, ids: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTagEventPersonal(xDataStoreID: string, ids: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTagEventPersonal(xDataStoreID: string, ids: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTagEventPersonal(xDataStoreID: string, ids: Array<number>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteTagEventPersonal.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling deleteTagEventPersonal.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/tag-event-personals`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idTagEvent
     * @param status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public enableSchedule(xDataStoreID: string, idTagEvent: number, status: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public enableSchedule(xDataStoreID: string, idTagEvent: number, status: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public enableSchedule(xDataStoreID: string, idTagEvent: number, status: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public enableSchedule(xDataStoreID: string, idTagEvent: number, status: boolean, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling enableSchedule.');
        }

        if (idTagEvent === null || idTagEvent === undefined) {
            throw new Error('Required parameter idTagEvent was null or undefined when calling enableSchedule.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling enableSchedule.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(idTagEvent))}/schedule/${encodeURIComponent(String(status))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoryEvent(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<IHistoryEvent>>;
    public findHistoryEvent(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IHistoryEvent>>>;
    public findHistoryEvent(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IHistoryEvent>>>;
    public findHistoryEvent(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling findHistoryEvent.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<IHistoryEvent>>('get',`${this.basePath}/api/tag-event-history`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param tagEventId
     * @param timbre
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findPersonalForEvent(xDataStoreID: string, tagEventId: number, timbre: Date, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<IPersonalStatusLite>>;
    public findPersonalForEvent(xDataStoreID: string, tagEventId: number, timbre: Date, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IPersonalStatusLite>>>;
    public findPersonalForEvent(xDataStoreID: string, tagEventId: number, timbre: Date, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IPersonalStatusLite>>>;
    public findPersonalForEvent(xDataStoreID: string, tagEventId: number, timbre: Date, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling findPersonalForEvent.');
        }

        if (tagEventId === null || tagEventId === undefined) {
            throw new Error('Required parameter tagEventId was null or undefined when calling findPersonalForEvent.');
        }

        if (timbre === null || timbre === undefined) {
            throw new Error('Required parameter timbre was null or undefined when calling findPersonalForEvent.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tagEventId !== undefined && tagEventId !== null) {
            queryParameters = queryParameters.set('tagEventId', <any>tagEventId);
        }
        if (timbre !== undefined && timbre !== null) {
            queryParameters = queryParameters.set('timbre', <any>timbre.toISOString());
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<IPersonalStatusLite>>('get',`${this.basePath}/api/tag-event-history/personal`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idPersonal
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findTagsByPersonal(xDataStoreID: string, idPersonal: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TagStatusDTO>>;
    public findTagsByPersonal(xDataStoreID: string, idPersonal: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TagStatusDTO>>>;
    public findTagsByPersonal(xDataStoreID: string, idPersonal: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TagStatusDTO>>>;
    public findTagsByPersonal(xDataStoreID: string, idPersonal: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling findTagsByPersonal.');
        }

        if (idPersonal === null || idPersonal === undefined) {
            throw new Error('Required parameter idPersonal was null or undefined when calling findTagsByPersonal.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TagStatusDTO>>('get',`${this.basePath}/api/tag-event-history/personal/${encodeURIComponent(String(idPersonal))}/tag`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findTagsByPersonals(body: Array<number>, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<IPersonalTagLite>>;
    public findTagsByPersonals(body: Array<number>, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IPersonalTagLite>>>;
    public findTagsByPersonals(body: Array<number>, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IPersonalTagLite>>>;
    public findTagsByPersonals(body: Array<number>, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling findTagsByPersonals.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling findTagsByPersonals.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<IPersonalTagLite>>('post',`${this.basePath}/api/tag-event-history/personals/tags`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param X_PARTNER_ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countPersonalsForTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string | null, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countPersonalsForTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string | null, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countPersonalsForTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string | null, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countPersonalsForTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string | null, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling countPersonalsForTagByDataview.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling countPersonalsForTagByDataview.');
        }

        // X_PARTNER_ID facultatif : sans lui, l'engine prend l'affilié du tenant.

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/tag-event-dataview/count-personals`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTagEventPersonals(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<TagEventPersonalDTO>>;
    public getAllTagEventPersonals(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TagEventPersonalDTO>>>;
    public getAllTagEventPersonals(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TagEventPersonalDTO>>>;
    public getAllTagEventPersonals(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTagEventPersonals.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TagEventPersonalDTO>>('get',`${this.basePath}/api/tag-event-personals`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param X_PARTNER_ID
     * @param tagEventId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistoryDetail(xDataStoreID: string, tagEventId: number, observe?: 'body', reportProgress?: boolean): Observable<DetailEventTagDTO>;
    public getHistoryDetail(xDataStoreID: string, tagEventId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DetailEventTagDTO>>;
    public getHistoryDetail(xDataStoreID: string, tagEventId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DetailEventTagDTO>>;
    public getHistoryDetail(xDataStoreID: string, tagEventId: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getHistoryDetail.');
        }

        if (tagEventId === null || tagEventId === undefined) {
            throw new Error('Required parameter tagEventId was null or undefined when calling getHistoryDetail.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tagEventId !== undefined && tagEventId !== null) {
            queryParameters = queryParameters.set('tagEventId', <any>tagEventId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DetailEventTagDTO>('get',`${this.basePath}/api/tag-event-history/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTagEventPersonal(xDataStoreID: string, id: number, observe?: 'body', reportProgress?: boolean): Observable<TagEventPersonalDTO>;
    public getTagEventPersonal(xDataStoreID: string, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagEventPersonalDTO>>;
    public getTagEventPersonal(xDataStoreID: string, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagEventPersonalDTO>>;
    public getTagEventPersonal(xDataStoreID: string, id: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTagEventPersonal.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTagEventPersonal.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TagEventPersonalDTO>('get',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param tagEventId
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTimbreForTagEvent(xDataStoreID: string, tagEventId: number, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<ITimbreQte>>;
    public getTimbreForTagEvent(xDataStoreID: string, tagEventId: number, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ITimbreQte>>>;
    public getTimbreForTagEvent(xDataStoreID: string, tagEventId: number, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ITimbreQte>>>;
    public getTimbreForTagEvent(xDataStoreID: string, tagEventId: number, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTimbreForTagEvent.');
        }

        if (tagEventId === null || tagEventId === undefined) {
            throw new Error('Required parameter tagEventId was null or undefined when calling getTimbreForTagEvent.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tagEventId !== undefined && tagEventId !== null) {
            queryParameters = queryParameters.set('tagEventId', <any>tagEventId);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ITimbreQte>>('get',`${this.basePath}/api/tag-event-history/timbres`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partialUpdateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe?: 'body', reportProgress?: boolean): Observable<TagEventPersonalDTO>;
    public partialUpdateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagEventPersonalDTO>>;
    public partialUpdateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagEventPersonalDTO>>;
    public partialUpdateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling partialUpdateTagEventPersonal.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling partialUpdateTagEventPersonal.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling partialUpdateTagEventPersonal.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TagEventPersonalDTO>('patch',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param X_PARTNER_ID
     * @param idTagEvent
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public run(xDataStoreID: string, X_PARTNER_ID: string | null, idTagEvent: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public run(xDataStoreID: string, X_PARTNER_ID: string | null, idTagEvent: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public run(xDataStoreID: string, X_PARTNER_ID: string | null, idTagEvent: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public run(xDataStoreID: string, X_PARTNER_ID: string | null, idTagEvent: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling run.');
        }

        // X_PARTNER_ID facultatif : sans lui, l'engine prend l'affilié de la règle (sinon celui du tenant).

        if (idTagEvent === null || idTagEvent === undefined) {
            throw new Error('Required parameter idTagEvent was null or undefined when calling run.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(idTagEvent))}/run`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idTagEvent
     * @param cron
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCron(xDataStoreID: string, idTagEvent: number, cron: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateCron(xDataStoreID: string, idTagEvent: number, cron: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateCron(xDataStoreID: string, idTagEvent: number, cron: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateCron(xDataStoreID: string, idTagEvent: number, cron: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateCron.');
        }

        if (idTagEvent === null || idTagEvent === undefined) {
            throw new Error('Required parameter idTagEvent was null or undefined when calling updateCron.');
        }

        if (cron === null || cron === undefined) {
            throw new Error('Required parameter cron was null or undefined when calling updateCron.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(idTagEvent))}/cron/${encodeURIComponent(String(cron))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePersonalTag(body: { [key: string]: boolean; }, xDataStoreID: string, id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updatePersonalTag(body: { [key: string]: boolean; }, xDataStoreID: string, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updatePersonalTag(body: { [key: string]: boolean; }, xDataStoreID: string, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updatePersonalTag(body: { [key: string]: boolean; }, xDataStoreID: string, id: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updatePersonalTag.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updatePersonalTag.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePersonalTag.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(id))}/tag`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param X_PARTNER_ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePersonalTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public updatePersonalTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public updatePersonalTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public updatePersonalTagByDataview(body: UpdateTagByDataviewDTO, xDataStoreID: string, X_PARTNER_ID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updatePersonalTagByDataview.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updatePersonalTagByDataview.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling updatePersonalTagByDataview.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('put',`${this.basePath}/api/tag-event-dataview`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe?: 'body', reportProgress?: boolean): Observable<TagEventPersonalDTO>;
    public updateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagEventPersonalDTO>>;
    public updateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagEventPersonalDTO>>;
    public updateTagEventPersonal(body: TagEventPersonalDTO, xDataStoreID: string, id: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTagEventPersonal.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTagEventPersonal.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTagEventPersonal.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TagEventPersonalDTO>('put',`${this.basePath}/api/tag-event-personals/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
